import { draftSubHire } from "@/utils/constants";
import { handleError, handleResponse } from "@/utils/functions";

export default (axios) => ({
  getDraftSubHireList(params = {}) {
    return new Promise((resolve, reject) => {
      axios
        .get(draftSubHire.draftSubHireBase, { params })
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
  getDraftSubHireObject(id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`${draftSubHire.draftSubHireBase}${id}/`)
        .then((res) => resolve(handleResponse(res)))
        .catch((err) => reject(handleError(err)));
    });
  },
});
